<div class="grid">
    <div class="col-6">
        <div class="text-center pt-5">
            <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-12">
                    <p-dropdown [(ngModel)]="draftProjectService.draftProject().idProyectoSector" id="sector"
                                [options]="sectores" optionLabel="descripcion" optionValue="id" [showClear]="true"
                                [checkmark]="true"
                                (onChange)="tipoSector(draftProjectService.draftProject().idProyectoSector!)"
                                [filter]="true"
                                filterBy="descripcion"
                                placeholder="Seleccione el tipo de sector *"
                                [required]="true"
                                [ngClass]="{'ng-invalid ng-dirty' : campoCompleto && !draftProjectService.draftProject().idProyectoSector}"
                                [pTooltip]="draftProjectService.draftProject().idProyectoSector?'':'Seleccione el tipo de sector'"
                                tooltipPosition="top"></p-dropdown>
                    <small style="color:red" class="ng-dirty ng-invalid"
                           *ngIf="campoCompleto && !draftProjectService.draftProject().idProyectoSector"><b>Favor
                        seleccione el tipo de sector</b></small>
                </div>
                <div class="field col-12 md:col-12" *ngIf="draftProjectService.draftProject().idProyectoSector==1">
                    <p-dropdown [(ngModel)]="draftProjectService.draftProject().idProyectoInstitucion" id="idInstitucion"
                                [options]="instituciones" optionLabel="nombre" optionValue="idInstitucion"
                                [showClear]="true"
                                [checkmark]="true"
                                (onChange)="setProyectoInstitucion(draftProjectService.draftProject().idProyectoInstitucion!)"
                                [filter]="true"
                                filterBy="nombre"
                                placeholder="Seleccione una Institución *"
                                [required]="true"
                                [ngClass]="{'ng-invalid ng-dirty' : campoCompleto && !draftProjectService.draftProject().idProyectoInstitucion}"
                                [pTooltip]="draftProjectService.draftProject().idProyectoInstitucion?'':'Seleccione una Institución'"
                                tooltipPosition="top"></p-dropdown>
                    <small style="color:red" class="ng-dirty ng-invalid"
                           *ngIf="campoCompleto && !draftProjectService.draftProject().idProyectoInstitucion"><b>Favor
                        seleccione una
                        Institución</b></small>
                </div>

                <div class="field col-12 md:col-12">
                    <p-dropdown [(ngModel)]="draftProjectService.draftProject().idTipoProyecto" id="tipoProyecto"
                                [options]="tipoList" optionLabel="descripcion" optionValue="id" [showClear]="true"
                                [checkmark]="true"
                                (onChange)="tipoProyecto(draftProjectService.draftProject().idTipoProyecto!)"
                                [filter]="true"
                                filterBy="descripcion"
                                placeholder="Seleccione tipo de proyecto *"
                                [required]="true"
                                [ngClass]="{'ng-invalid ng-dirty' : campoCompleto && !draftProjectService.draftProject().idTipoProyecto}"
                                [pTooltip]="draftProjectService.draftProject().idTipoProyecto?'':'Seleccione el tipo del proyecto'"
                                tooltipPosition="top"></p-dropdown>
                    <small style="color:red" class="ng-dirty ng-invalid"
                           *ngIf="campoCompleto && !draftProjectService.draftProject().idTipoProyecto"><b>Favor
                        seleccione el tipo del proyecto</b></small>
                </div>
                <div class="field col-12 md:col-12">
                    <span class="p-float-label">
            <input id="nombreProyecto" type="text" #nombreInput required
                   [(ngModel)]="draftProjectService.draftProject().nombre"
                   [ngClass]="{'ng-invalid ng-dirty' : campoCompleto && !draftProjectService.draftProject().nombre}"
                   pInputText (keydown)="isCharactersValid($event)"
                   [pTooltip]="draftProjectService.draftProject().nombre?'':'Ingresar nombre del proyecto'"
                   tooltipPosition="top"/>
            <label for="nombreProyecto" class="mb-2">Nombre asignado al proyecto <small
                style="color:red"><b>*</b></small></label>
        </span>
                    <small style="color:red" class="ng-dirty ng-invalid"
                           *ngIf="campoCompleto && !draftProjectService.draftProject().nombre"><b>Favor
                        ingresar el nombre del proyecto</b></small>
                </div>
                <div class="field col-12 md:col-12">
                    <small style="color:red" class="ng-dirty ng-invalid"
                           *ngIf="(draftProjectService.draftProject().descripcion?.length || 0) > 2000"><b>Cantidad máxima permitida: 2000 carácteres</b></small>
                    <span class="p-float-label">
                        <textarea #descripcionInput required [(ngModel)]="draftProjectService.draftProject().descripcion"
                                  [ngClass]="{'ng-invalid ng-dirty' : campoCompleto && !draftProjectService.draftProject().descripcion}"
                                  rows="1" cols="30" pInputTextarea
                                  [autoResize]="true" id="descripcionProyecto" (keydown)="isCharactersValid($event)"
                                  [pTooltip]="draftProjectService.draftProject().descripcion?'':'Ingresar descripción del proyecto'"
                                  tooltipPosition="top"></textarea>
                        <label for="descripcionProyecto">Descripción <small style="color:red"><b>*</b></small></label>
                    </span>
                    <small style="color:red" class="ng-dirty ng-invalid"
                           *ngIf="campoCompleto && !draftProjectService.draftProject().descripcion"><b>Favor
                        ingresar la descripción del proyecto</b></small>
                </div>
            </div>
        </div>
    </div>
    <div class="col-6">
        <div class="text-center pt-5">
            <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-12">
                    <p-dropdown [(ngModel)]="draftProjectService.draftProject().idNaturaleza" #naturalezaDrop
                                [options]="naturalezaList" optionLabel="descripcion" optionValue="id" [showClear]="true"
                                placeholder="Seleccione naturaleza *"
                                [checkmark]="true"
                                [filter]="true"
                                filterBy="descripcion"
                                [required]="true"
                                [ngClass]="{'ng-invalid ng-dirty' : campoCompleto && !draftProjectService.draftProject().idNaturaleza}"
                                [pTooltip]="draftProjectService.draftProject().idNaturaleza?'':'Seleccione la naturaleza del proyecto'"
                                tooltipPosition="top"></p-dropdown>
                    <small style="color:red" class="ng-dirty ng-invalid"
                           *ngIf="campoCompleto && !draftProjectService.draftProject().idNaturaleza"><b>Favor
                        seleccione la naturaleza del proyecto</b></small>
                </div>
                <div class="field col-12 md:col-12">
                    <p-dropdown #dropPrueba [(ngModel)]="draftProjectService.draftProject().idEntorno"
                                id="entornoProyecto" [options]="entornoList" optionLabel="descripcion" optionValue="id"
                                [showClear]="true"
                                [checkmark]="true"
                                [filter]="true"
                                filterBy="descripcion"
                                placeholder="Seleccione entorno del proyecto *" [required]="true"
                                [ngClass]="{'ng-invalid ng-dirty' : campoCompleto && !draftProjectService.draftProject().idEntorno}"
                                [pTooltip]="draftProjectService.draftProject().idEntorno?'':'Seleccione el entorno del proyecto'"
                                tooltipPosition="top"></p-dropdown>
                    <small style="color:red" class="ng-dirty ng-invalid"
                           *ngIf="campoCompleto && !draftProjectService.draftProject().idEntorno"><b>Favor
                        seleccione el entorno del proyecto</b></small>
                </div>
                <div *ngIf="showRegimen" class="field col-12 md:col-12">
                    <p-dropdown *ngIf="showRegimen" [(ngModel)]="draftProjectService.draftProject().idRegimen"
                                id="regimenProyecto" [options]="regimenList" optionLabel="descripcion" optionValue="id"
                                [showClear]="true"
                                [checkmark]="true"
                                [filter]="true"
                                filterBy="descripcion"
                                placeholder="Seleccione régimen del proyecto" [required]="true"
                                [ngClass]="{'ng-invalid ng-dirty' : campoCompleto && !draftProjectService.draftProject().idRegimen && showRegimen}"
                                [pTooltip]="draftProjectService.draftProject().idRegimen?'':'Seleccione el régimen del proyecto'"
                                tooltipPosition="top"></p-dropdown>
                    <small style="color:red" class="ng-dirty ng-invalid"
                           *ngIf="campoCompleto && !draftProjectService.draftProject().idRegimen && showRegimen"><b>Favor
                        seleccione el régimen del
                        proyecto</b></small>
                </div>
                <div class="field col-12 md:col-12">
                    <p-dropdown id="sueloProyecto" [(ngModel)]="draftProjectService.draftProject().idTipoUsoSuelo"
                                [options]="usoSueloList"
                                [checkmark]="true"
                                [filter]="true"
                                filterBy="descripcion"
                                optionLabel="descripcion" optionValue="id" [showClear]="true"
                                placeholder="Seleccione uso del suelo *" [required]="true"
                                [ngClass]="{'ng-invalid ng-dirty' : campoCompleto && !draftProjectService.draftProject().idTipoUsoSuelo}"
                                [pTooltip]="draftProjectService.draftProject().idTipoUsoSuelo?'':'Seleccione el uso del suelo del proyecto'"
                                tooltipPosition="top"></p-dropdown>
                    <small style="color:red" class="ng-dirty ng-invalid"
                           *ngIf="campoCompleto && !draftProjectService.draftProject().idTipoUsoSuelo"><b>Favor
                        seleccione el uso del suelo</b></small>
                </div>
                 <div class="field col-12 md:col-12">
                    <p class="font-bold">¿Ya tienes un proyecto definido?</p>
                    <p-checkbox 
                        inputId="proyectoDefinido" 
                        [(ngModel)]="draftProjectService.draftProject().tieneProyectoDefinido"
                        [binary]="true"
                        [ngClass]="{'ng-invalid ng-dirty': campoCompleto && draftProjectService.draftProject().tieneProyectoDefinido === null}"
                        [pTooltip]="draftProjectService.draftProject().tieneProyectoDefinido === null ? 'Seleccione si tiene un proyecto definido' : ''"
                        tooltipPosition="top">
                    </p-checkbox>
                    <label for="proyectoDefinido" class="ml-2">Sí, ya tengo un proyecto definido</label>
                </div>
            </div>
        </div>
    </div>
</div>

